import clsx from 'clsx';
import React, { PropsWithChildren } from 'react';
import {
  Colors,
  ColorsType,
  FontSize,
  FontWeight,
  LineHeight,
} from '@common/tokens';

type Props = {
  size?: 'h1' | 'h2' | 'h3' | 'h4';
  weight?: 'light' | 'medium' | 'bold';
  color?: ColorsType;
  className?: string;
  center?: boolean;
};

export function Title({
  size = 'h2',
  weight = 'light',
  color = 'textDefault',
  className,
  center,
  children,
}: PropsWithChildren<Props>) {
  const colorHash = Colors[color];
  const internalClassName = clsx(
    className,
    `wk-title wk-title-weight--${weight}`,
    {
      'wk-title--center': center,
    }
  );

  return (
    <>
      {size === 'h1' ? (
        <h1 className={internalClassName}>{children}</h1>
      ) : size === 'h2' ? (
        <h2 className={internalClassName}>{children}</h2>
      ) : size === 'h3' ? (
        <h3 className={internalClassName}>{children}</h3>
      ) : size === 'h4' ? (
        <h4 className={internalClassName}>{children}</h4>
      ) : null}

      <style jsx>{`
        .wk-title {
          color: ${colorHash};
          margin-bottom: 0;
        }
        h1.wk-title {
          font-size: ${FontSize['4xl']};
          line-height: ${LineHeight.xxxl};
        }
        h2.wk-title {
          font-size: ${FontSize.xxl};
          line-height: ${LineHeight.xxl};
        }
        h3.wk-title {
          font-size: ${FontSize.xl};
          line-height: ${LineHeight.lg};
        }
        h4.wk-title {
          font-size: ${FontSize.lg};
          line-height: ${LineHeight.xl};
        }
        .wk-title--center {
          text-align: center;
        }
        .wk-title-weight--light {
          font-weight: ${FontWeight.light};
        }
        .wk-title-weight--medium {
          font-weight: ${FontWeight.medium};
        }
        .wk-title-weight--bold {
          font-weight: ${FontWeight.bold};
        }
      `}</style>
    </>
  );
}
